import GroupEdit from './group.edit';
import GroupCreate from './group.create';
import GroupShow from './group.show';
import GroupList from './group.list';

export default {
  edit: GroupEdit,
  create: GroupCreate,
  show: GroupShow,
  list: GroupList,
};
